export default {
  1: 'MALE',
  2: 'FEMALE',
  3: 'UNINFORMED'
}



// WEBPACK FOOTER //
// ./src/Participant/genderTypes.js